import init from "@kilokilo/ewz-interactive-building";

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".comp-interactive-building");
    element.setAttribute("aria-description", "Komplexe interaktive Visualisierung mit Links, welche weiter unten barrierefrei auffindbar sind");
    element.setAttribute("role", "presentation");
    init(element);
});
